import styled from 'styled-components';
import { Dispatch, SetStateAction } from 'react';
import iconClose from '../assets/icon_close.svg';

interface PrivacyPolicyProps {
  isOpenModal: boolean;
  setIsOpenModal: Dispatch<SetStateAction<boolean>>;
}

const PrivacyPolicy = (props: PrivacyPolicyProps) => {
  const { isOpenModal, setIsOpenModal } = props;

  return (
    <>
      {isOpenModal === true ? (
        <>
          <DimModalContainer>
            <BackgroundDim></BackgroundDim>
            <ModalDiv>
              <IconWrap>
                <CloseImg
                  src={iconClose}
                  alt="닫기"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsOpenModal(false);
                  }}
                />
              </IconWrap>
              <IframeContainer>
                <iframe width="100%" height="100%" src="/privacyPolicy.html"></iframe>
              </IframeContainer>
            </ModalDiv>
          </DimModalContainer>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default PrivacyPolicy;

const DimModalContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
`;

const BackgroundDim = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.7;
  background: var(--neutral-gray-900);
`;

const ModalDiv = styled.div`
  width: 50%;
  height: 80%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2.5rem 4rem;

  z-index: 99;

  border-radius: 1rem;
  background: var(--neutral-white);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.25);
`;

const IconWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  margin-bottom: 1rem;
`;

const CloseImg = styled.img`
  width: 3.2rem;
  cursor: pointer;
`;

const IframeContainer = styled.div`
  width: 100%;
  height: calc(100% - 6.7rem);
`;

// const ModalTitle = styled.p`
//   width: 100%;
//   color: var(--neutral-gray-800);
// `;

// const ModalBtnWrap = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: flex-end;
// `;

// const ModalBtn = styled.button<{ isConfirmButtonStyle: boolean }>`
//   color: ${(props) =>
//     props.isConfirmButtonStyle ? 'var(--primary-ivy-green-600)' : 'var(--neutral-gray-600)'};
//   background-color: transparent;
//   font-family: Pretendard;
//   font-size: 1.6rem;
//   font-style: normal;
//   font-weight: 700;
//   line-height: 2rem; /* 125% */
//   letter-spacing: 0.0016rem;
//   text-decoration-line: underline;
// `;
